class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

// The state survives AJAX replacements of the drawer, but never needs a page reload.
window.__afSideCartUI = window.__afSideCartUI || {
  coupon: {open: false, draft: '', error: ''},
  note: {open: false, draft: null}
};

class CouponCode extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.input = this.querySelector('input[name="discount"]');
    this.applyButton = this.querySelector('[data-update-coupon]');
    this.removeButton = this.querySelector('[data-remove-coupon]');
    this.errorElement = this.querySelector('[data-coupon-error]');
    const ui = window.__afSideCartUI.coupon;
    if (this.input) this.input.value = ui.draft || '';
    this.applyButton?.addEventListener('click', () => this.applyCode());
    this.removeButton?.addEventListener('click', () => this.removeCode());
    this.input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') { event.preventDefault(); this.applyCode(); }
    });
    this.input?.addEventListener('input', () => {
      ui.draft = this.input.value;
      if (ui.error) this.setError('');
    });
    this.setError(ui.error, false);
    this.syncRemoveButton();
    this.syncAppliedDiscountRemoveButtons();
    // This handler belongs to document, not the AJAX-replaced coupon element.
    if (!window.__afSideCartDiscountDelegated) {
      window.__afSideCartDiscountDelegated = true;
      document.addEventListener('click', (event) => {
        const removeOne = event.target.closest('[data-remove-discount-code]');
        const removeAll = event.target.closest('[data-remove-all-discount-codes]');
        const clicked = removeOne || removeAll;
        if (!clicked || !clicked.closest('#halo-cart-sidebar')) return;
        event.preventDefault();
        const coupon = document.querySelector('#halo-cart-sidebar coupon-code.af-sidecart-coupon');
        if (removeOne) coupon?.removeSpecificCode(removeOne.dataset.removeDiscountCode, removeOne);
        else coupon?.removeCode();
      });
    }
  }

  getText(key, fallback) {
    // Read labels from the current, localized AJAX-rendered drawer markup.
    const current = document.querySelector('#halo-cart-sidebar coupon-code.af-sidecart-coupon') || this;
    return current?.dataset?.[key] || fallback;
  }
  getRoot() {
    const root = window.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  }
  uniqueCodes(codes) {
    const seen = new Set();
    return (codes || []).map(x => String(x || '').trim()).filter(x => {
      const key = x.toLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key); return true;
    });
  }
  getStoredCodes() {
    try {
      const codes = JSON.parse(localStorage.getItem('storedDiscountCodes') || '[]');
      if (Array.isArray(codes) && codes.length) return this.uniqueCodes(codes);
    } catch (_) {}
    const legacy = localStorage.getItem('storedDiscount');
    return legacy ? [legacy] : [];
  }
  syncStoredCodes(codes) {
    const clean = this.uniqueCodes(codes);
    if (clean.length) {
      localStorage.setItem('storedDiscountCodes', JSON.stringify(clean));
      localStorage.setItem('storedDiscount', clean[clean.length - 1]);
    } else {
      localStorage.removeItem('storedDiscountCodes');
      localStorage.removeItem('storedDiscount');
    }
    this.syncRemoveButton(clean);
    return clean;
  }
  getCurrentCodes() {
    const drawer = document.querySelector('#halo-cart-sidebar');
    const applied = drawer ? Array.from(drawer.querySelectorAll('[data-discount-code]')).map(x => x.dataset.discountCode) : [];
    return this.uniqueCodes([...applied, ...this.getStoredCodes()]);
  }
  async getCart() {
    const result = await fetch(this.getRoot() + 'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'}});
    if (!result.ok) throw new Error('Could not read cart');
    return result.json();
  }
  getDiscountTitles(cart) {
    const names = [];
    (cart.discount_codes || []).forEach(d => { if (d.applicable !== false && d.code) names.push(d.code); });
    (cart.cart_level_discount_applications || []).forEach(d => { if (d.title) names.push(d.title); });
    (cart.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(a => {
      if (a.discount_application?.title) names.push(a.discount_application.title);
    }));
    return names.map(x => String(x).trim().toLowerCase());
  }
  isCodeApplied(cart, code) {
    return this.getDiscountTitles(cart).includes(String(code || '').trim().toLowerCase());
  }
  async updateCodes(codes) {
    const result = await fetch(this.getRoot() + 'cart/update.js', {
      method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({discount:this.uniqueCodes(codes).join(',')})
    });
    if (!result.ok) throw new Error('Could not update discounts');
    return result.json();
  }
  refreshSidebar(cart) {
    if (window.sharedFunctions?.updateSidebarCart) window.sharedFunctions.updateSidebarCart(cart);
    else if (window.Shopify?.getCart) window.Shopify.getCart(c => window.sharedFunctions?.updateSidebarCart?.(c));
    document.dispatchEvent(new CustomEvent('af:side-cart-discounts-updated',{detail:{cart}}));
  }
  setError(message, persist = true) {
    if (persist) window.__afSideCartUI.coupon.error = message || '';
    // Find the CURRENT element, not an old node destroyed by the theme's cart refresh.
    const current = document.querySelector('#halo-cart-sidebar coupon-code.af-sidecart-coupon');
    const error = current?.querySelector('[data-coupon-error]') || this.errorElement;
    const input = current?.querySelector('input[name="discount"]') || this.input;
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
    if (input) input.setAttribute('aria-invalid',message ? 'true' : 'false');
    if (message) {
      window.__afSideCartUI.coupon.open = true;
      const toggle = document.querySelector('#halo-cart-sidebar [data-discount-toggle]');
      const panel = document.querySelector('#halo-cart-sidebar #af-sidecart-discount-form');
      if (toggle) toggle.setAttribute('aria-expanded','true');
      if (panel) panel.hidden = false;
    }
  }
  syncRemoveButton(codes = this.getStoredCodes()) {
    const hasCodes = codes.length > 0;
    if (this.removeButton) this.removeButton.hidden = !hasCodes;
    const removeAll = document.querySelector('#halo-cart-sidebar [data-remove-all-discount-codes]');
    if (removeAll) removeAll.hidden = !hasCodes;
  }
  syncAppliedDiscountRemoveButtons() {
    document.querySelectorAll('#halo-cart-sidebar .af-sidecart-discount-applied__code').forEach(tag => {
      const title = (tag.dataset.discountTitle || '').trim();
      const type = (tag.dataset.discountType || '').toLowerCase();
      if (!title || type !== 'discount_code') return; // Never delete automatic promotions.
      if (tag.querySelector('[data-remove-discount-code]')) return;
      const button = document.createElement('button');
      button.type='button'; button.className='af-sidecart-discount-applied__remove';
      button.dataset.removeDiscountCode=title;
      button.setAttribute('aria-label',this.getText('removeAria','Remove discount')+' '+title);
      button.textContent='×'; tag.appendChild(button);
    });
    this.syncRemoveButton(this.getCurrentCodes());
  }
  setLoading(value) {
    [this.applyButton,this.removeButton].forEach(b => { if(b) b.disabled=value; });
    document.querySelectorAll('#halo-cart-sidebar [data-remove-discount-code],#halo-cart-sidebar [data-remove-all-discount-codes]').forEach(b => b.disabled=value);
  }
  async applyCode() {
    const code = (this.input?.value || '').trim();
    const ui = window.__afSideCartUI.coupon;
    if (!code) { this.setError(this.getText('errorRequired','Please enter a discount code.')); this.input?.focus(); return; }
    const current = this.getCurrentCodes();
    if (current.some(c => c.toLowerCase()===code.toLowerCase())) {
      this.setError(this.getText('errorDuplicate','This discount code is already applied.')); return;
    }
    this.setLoading(true);
    this.setError('');
    const updated = [...current, code];
    try {
      await this.updateCodes(updated);
      const cart = await this.getCart();
      if (!this.isCodeApplied(cart,code)) {
        // Shopify might have temporarily replaced old codes: restore them silently.
        // Do NOT rebuild the entire cart for an invalid code: the error stays visible.
        await this.updateCodes(current);
        this.syncStoredCodes(current);
        this.setError(this.getText('errorInvalid','Invalid discount code or not eligible for this order.'));
        ui.open = true;
        return;
      }
      this.syncStoredCodes(updated.filter(c => this.isCodeApplied(cart,c)));
      ui.open = false;
      ui.draft = '';
      this.setError('');
      if (this.input) this.input.value = '';
      this.refreshSidebar(cart);
    } catch (e) {
      console.error('Side cart discount apply:', e);
      this.setError(this.getText('errorApply','We could not apply the code. Please try again.'));
    } finally {
      this.setLoading(false);
      this.syncRemoveButton(this.getCurrentCodes());
    }
  }
  async removeSpecificCode(code, button) {
    const current = this.getCurrentCodes();
    const remaining = current.filter(x => x.toLowerCase()!==String(code||'').trim().toLowerCase());
    if (remaining.length===current.length) return;
    if (button) button.disabled=true;
    this.setLoading(true); this.setError('');
    try {
      await this.updateCodes(remaining);
      const cart = await this.getCart();
      this.syncStoredCodes(remaining.filter(c => this.isCodeApplied(cart,c)));
      this.refreshSidebar(cart);
    } catch(e) {
      console.error('Side cart remove discount:',e);
      this.setError(this.getText('errorRemove','We could not remove this code. Please try again.'));
    } finally { this.setLoading(false); }
  }
  async removeCode() {
    const previous = this.getCurrentCodes();
    this.setLoading(true); this.setError('');
    try {
      await this.updateCodes([]);
      const cart = await this.getCart();
      this.syncStoredCodes([]);
      this.refreshSidebar(cart);
    } catch(e) {
      this.syncStoredCodes(previous);
      this.setError(this.getText('errorRemoveAll','We could not remove the codes. Please try again.'));
      console.error('Side cart remove all codes:',e);
    } finally { this.setLoading(false); }
  }
}
if (!customElements.get('coupon-code')) customElements.define('coupon-code', CouponCode);


class SideCartDiscount extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.toggle = this.querySelector('[data-discount-toggle]');
    this.panel = this.querySelector('.af-sidecart-discount__form');
    const ui = window.__afSideCartUI.coupon;
    this.setOpen(Boolean(ui.open || ui.error));
    this.toggle?.addEventListener('click', () => {
      this.setOpen(this.toggle?.getAttribute('aria-expanded') !== 'true');
      if (!this.panel?.hidden) this.querySelector('input[name="discount"]')?.focus();
    });
  }
  setOpen(open) {
    window.__afSideCartUI.coupon.open = open;
    if (this.panel) this.panel.hidden = !open;
    this.toggle?.setAttribute('aria-expanded',String(open));
  }
}
if (!customElements.get('side-cart-discount')) customElements.define('side-cart-discount', SideCartDiscount);

class SideCartNote extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized=true;
    this.toggle=this.querySelector('[data-sidecart-note-toggle]');
    this.panel=this.querySelector('.af-sidecart-note__panel');
    this.input=this.querySelector('[data-sidecart-note-input]');
    this.counter=this.querySelector('[data-sidecart-note-count]');
    this.status=this.querySelector('[data-sidecart-note-status]');
    const ui=window.__afSideCartUI.note;
    if (ui.draft!==null && this.input) this.input.value=ui.draft;
    this.savedValue=this.input?.defaultValue || '';
    this.updateCount();
    this.setOpen(Boolean(ui.open));
    this.toggle?.addEventListener('click',()=>{
      const open=this.toggle.getAttribute('aria-expanded')!=='true';
      this.setOpen(open);
      if (open) this.input?.focus(); else this.flushSave();
    });
    this.input?.addEventListener('input',()=>{
      ui.draft=this.input.value;
      this.updateCount();
      this.showStatus('');
      clearTimeout(this.saveTimer);
      this.saveTimer=setTimeout(()=>this.save(),900);
    });
    this.input?.addEventListener('blur',()=>this.flushSave());
  }
  updateCount() {
    if(this.counter) this.counter.textContent=String(this.input?.value.length || 0);
  }
  setOpen(open) {
    window.__afSideCartUI.note.open=open;
    if(this.panel) this.panel.hidden=!open;
    this.toggle?.setAttribute('aria-expanded',String(open));
  }
  showStatus(message,isError=false) {
    if(!this.status) return;
    this.status.textContent=message;
    this.status.classList.toggle('is-error',isError);
  }
  flushSave() {
    clearTimeout(this.saveTimer);
    if(this.input && this.input.value!==this.savedValue) this.save();
  }
  async save() {
    const value=this.input?.value || '';
    clearTimeout(this.saveTimer);
    if(value===this.savedValue || this.isSaving) return;
    this.isSaving=true;
    this.showStatus(this.dataset.noteSaving || 'Saving...');
    try {
      const root=window.routes?.root || '/';
      const url=(root.endsWith('/') ? root : root+'/')+'cart/update.js';
      const res=await fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note:value})});
      if(!res.ok) throw new Error('Note update failed');
      this.savedValue=value;
      window.__afSideCartUI.note.draft=null;
      this.showStatus(this.dataset.noteSaved || 'Saved');
    } catch(e) {
      console.error('Side cart note save:',e);
      this.showStatus(this.dataset.noteError || 'Unable to save note. Please try again.',true);
    } finally {
      this.isSaving=false;
      if(this.input && this.input.value!==this.savedValue && this.isConnected) {
        clearTimeout(this.saveTimer);
        this.saveTimer=setTimeout(()=>this.save(),850);
      }
    }
  }
  disconnectedCallback() {
    clearTimeout(this.saveTimer);
    if(this.input && this.input.value!==this.savedValue) this.save();
  }
}
if (!customElements.get('side-cart-note')) customElements.define('side-cart-note',SideCartNote);


class SideCartInstallments extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('[data-installments-toggle]');
    this.backdrop = this.querySelector('[data-installments-panel]');
    this.dialog = this.querySelector('.af-sidecart-installments__dialog');
    this.closeButtons = this.querySelectorAll('[data-installments-close]');
    this.originalParent = this.backdrop?.parentNode || null;
    this.originalNext = this.backdrop?.nextSibling || null;
    this.lastFocus = null;
    this.toggle?.addEventListener('click', () => this.open());
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.backdrop?.addEventListener('click', (event) => {
      if (event.target === this.backdrop) this.close();
    });
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.backdrop && !this.backdrop.hidden) this.close();
    };
    document.addEventListener('keydown', this.onKeydown);
  }
  open() {
    if (!this.backdrop) return;
    this.lastFocus = document.activeElement;
    this.originalParent = this.backdrop.parentNode;
    this.originalNext = this.backdrop.nextSibling;
    document.body.appendChild(this.backdrop);
    this.backdrop.hidden = false;
    this.backdrop.setAttribute('aria-hidden', 'false');
    this.toggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('af-sidecart-installments-open');
    requestAnimationFrame(() => {
      this.dialog?.focus();
      window.dispatchEvent(new Event('resize'));
    });
  }
  close() {
    if (!this.backdrop) return;
    this.backdrop.hidden = true;
    this.backdrop.setAttribute('aria-hidden', 'true');
    this.toggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('af-sidecart-installments-open');
    if (this.originalParent?.isConnected) {
      if (this.originalNext?.parentNode === this.originalParent) this.originalParent.insertBefore(this.backdrop, this.originalNext);
      else this.originalParent.appendChild(this.backdrop);
    }
    this.lastFocus?.focus?.();
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.classList.remove('af-sidecart-installments-open');
    if (this.backdrop && !this.backdrop.hidden && this.originalParent?.isConnected) this.originalParent.appendChild(this.backdrop);
  }
}
if (!customElements.get('side-cart-installments')) customElements.define('side-cart-installments', SideCartInstallments);